import Event from './Event';
import Contests from './Contests';
import BodyweightCategoriesEditor from './BodyweightCategoriesEditor';
import AgeGroupsPicker from './AgeGroupsPicker';
import { SubPagesLayout } from '../common';
//import HideableSection from '../../components/HideableSection';
import { Header } from '../../components';
import ormActions from '../../orm/actions';
import {
  createGendersSelector,
  createBodyweightCategoriesSelector,
  createAgeGroupsSelector,
  createContestsSelector,
} from '../../orm/selectors';
import { bickActions } from '../../common';

import React from 'react';
import { connect } from 'react-redux';

const Setup = ({
  app,
  route,
  actions,
  genders,
  contests,
  ageGroups,
  bodyweightCategories,
}) => {
  const AgeGroups = ({ breadcrumb }) => (
    <section>
      {breadcrumb}
      <Header as="h1">Age groups</Header>
      <AgeGroupsPicker
        actions={actions}
        meta={{ genders, bodyweightCategories, ageGroups, contests }}
      />
    </section>
  );

  const Expert = ({ breadcrumb }) => (
    <section>
      {breadcrumb}
      <Header as="h1">Expert</Header>
      <Header as="h2">Bodyweight categories</Header>
      <BodyweightCategoriesEditor
        id="setup--bodyweightCategories-editor"
        bodyweightCategories={bodyweightCategories}
        meta={{ genders }}
        actions={actions.bodyweightCategory}
      />
    </section>
  );

  /*
  const Breadcrumb = ({ sections }) => (
    <PageBreadcrumb
      sections={[{ key: 'setup', content: 'Setup' }, ...sections]}
    />
  );
  */

  return (
    <SubPagesLayout app={app} route={route}>
      {[
        { slug: '', title: 'Event', component: Event },
        { slug: 'age-groups', title: 'Age groups', component: AgeGroups },
        { slug: 'contests', title: 'Contests', component: Contests },
        ...(process.env.NODE_ENV !== 'production'
          ? [{ slug: 'expert', title: '*Expert*', component: Expert }]
          : []),
      ]}
    </SubPagesLayout>
  );
};

Setup.slug = 'setup';
Setup.title = 'Setup';

const mapStateToProps = () => {
  const gendersSelector = createGendersSelector();
  const bodyweightCategoriesSelector = createBodyweightCategoriesSelector();
  const ageGroupsSelector = createAgeGroupsSelector();
  const contestsSelector = createContestsSelector();

  return ({ orm }) => ({
    genders: gendersSelector(orm),
    ageGroups: ageGroupsSelector(orm),
    bodyweightCategories: bodyweightCategoriesSelector(orm),
    contests: contestsSelector(orm),
  });
};

const mapDispatchToProps = dispatch => ({
  actions: bickActions(ormActions, ['bodyweightCategory', 'contest'], dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Setup);



// WEBPACK FOOTER //
// ./src/pages/Setup/Setup.js